// extracted by mini-css-extract-plugin
export default {"ClientContainer":"Client_ClientContainer__Ub7aS","ClientEmpty":"Client_ClientEmpty__dJN3w"};